import { render, staticRenderFns } from "./DuplicateConflictsList.vue?vue&type=template&id=2c58894c&"
import script from "./DuplicateConflictsList.vue?vue&type=script&lang=js&"
export * from "./DuplicateConflictsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports